module.exports = __webpack_public_path__ + "892bf05ca80074bd65b1c4030586625e.png";